﻿import {
    MessageContent,
    MessageContentPartKind,
    MessageContentUpdateType
} from './types';

export default function getMessageContentPartKind(
    content: MessageContentUpdateType | MessageContent
) {
    if (content.text) {
        return MessageContentPartKind.Text;
    }

    if (
        ('refusalUpdate' in content && content.refusalUpdate) ||
        ('refusal' in content && content.refusal)
    ) {
        return MessageContentPartKind.Refusal;
    }

    if (content.imageFileId || content.imageDetail) {
        return MessageContentPartKind.Image;
    }

    return MessageContentPartKind.Text;
}
